import axios from 'axios';
import AlertBox from 'blocks/AlertBox';
import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import RouteDetail from 'components/Flight/RouteDetail';
import RecieptCard from 'components/RecieptCard';
import BaseModal from 'components/modals/BaseModal';
import Paths from 'helper/paths';
import { ClaimFlight } from 'pages/miles/Claim/claim.interface';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import urls from 'utils/urls';
import * as S from './checkMilageModal.styles';
import { ContentProps, MilageStatus } from './checkMile.interface';
import { FlightConfirmedInfo } from './responseType';

const Content = ({ open, closeModal, status, claimedFlight }: ContentProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [flightConfirmedInfo, setFlightConfirmedInfo] = useState<FlightConfirmedInfo[]>([]);
  const confirmFlight = async () => {
    setLoading(true);

    axios
      .post(urls.confirmedFlight, {
        flightIds: claimedFlight?.map((item) => item.id),
      })
      .then((res) => {
        toast.success(t('pages.miles.new.modal.checkMilage.success.toast'));
        if (res) {
          setFlightConfirmedInfo(res.data);
          closeModal();
        }
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <S.CheckModal>
      {status === MilageStatus.Success && claimedFlight && (
        <div>
          <S.InfoTitle>{t('pages.miles.new.modal.checkMilage.success.title')}</S.InfoTitle>

          {claimedFlight.map((flight) => (
            <BoxWrapper>
              <S.GrayCard>
                <RouteDetail flight={flight} key={flight.id} />

                <div>
                  <S.PointBoxBlue>
                    <S.PointBoxText>{t('pages.miles.new.modal.checkMilage.success.content.tierMiles')}</S.PointBoxText>
                    <S.PointBoxNumber>{flight.earnTierMilage}</S.PointBoxNumber>
                  </S.PointBoxBlue>

                  <S.PointBoxGreen>
                    <S.PointBoxTextGreen>
                      {t('pages.miles.new.modal.checkMilage.success.content.rewardMiles')}
                    </S.PointBoxTextGreen>
                    <S.PointBoxNumberGrren>{flight.earnRewardMilage}</S.PointBoxNumberGrren>
                  </S.PointBoxGreen>
                </div>
              </S.GrayCard>
            </BoxWrapper>
          ))}

          <S.BtnContainer>
            <S.Btn as={Button} loading={loading} onClick={confirmFlight} width={134}>
              {t('pages.miles.new.modal.checkMilage.success.confirmCTA')}
            </S.Btn>
          </S.BtnContainer>
        </div>
      )}
      {status === MilageStatus.SuccessfullyRegister && (
        <S.SuccessStep>
          <AlertBox type="success" text="Successfully">
            {t('pages.miles.new.modal.checkMilage.successfullyRegister.title')}
          </AlertBox>

          {flightConfirmedInfo.map((item) => (
            <BoxWrapper>
              <RecieptCard
                rows={[
                  {
                    id: 1,
                    name: t('pages.miles.new.modal.checkMilage.successfullyRegister.content.passengername'),
                    content: item.fullname,
                  },
                  {
                    id: 2,
                    name: t('pages.miles.new.modal.checkMilage.successfullyRegister.content.flightNumber'),
                    content: item.flightNo,
                  },
                  {
                    id: 3,
                    name: t('pages.miles.new.modal.checkMilage.successfullyRegister.content.rewardMilesNO'),
                    content: item.rewardMilage,
                  },
                  {
                    id: 4,
                    name: t('pages.miles.new.modal.checkMilage.successfullyRegister.content.tierMilesNO'),
                    content: item.tierMilage,
                  },
                ]}
              />
            </BoxWrapper>
          ))}

          <S.BtnContainer>
            <S.Btn as={Button} styleType="default" onClick={closeModal}>
              {t('pages.miles.new.modal.checkMilage.successfullyRegister.closeCTA')}
            </S.Btn>
          </S.BtnContainer>
        </S.SuccessStep>
      )}
      {status === MilageStatus.NotMatch && (
        <S.ParentAlert>
          <AlertBox type="error" text="Error">
            {t('pages.miles.new.modal.checkMilage.notMatch.title')}
          </AlertBox>

          <S.BtnContainer>
            <S.Btn as={Button} styleType="text-button" onClick={closeModal}>
              {t('pages.miles.new.modal.checkMilage.notMatch.closeCTA')}
            </S.Btn>
            <S.Btn as={Button} type="link" href={Paths.Miles.new().route} styleType="default">
              {t('pages.miles.new.modal.checkMilage.notMatch.addNewMilageCTA')}
            </S.Btn>
          </S.BtnContainer>
        </S.ParentAlert>
      )}
      {status === MilageStatus.Invalid && (
        <>
          <AlertBox type="error" text="Error">
            {t('pages.miles.new.modal.checkMilage.invalid.title')}
          </AlertBox>
        </>
      )}
    </S.CheckModal>
  );
};

interface State {
  open: boolean;
  status: MilageStatus;
  claimedFlight?: ClaimFlight[] | [];
}

interface Props {
  ref: any;
}

class CheckMilageModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      status: MilageStatus.Invalid,
      claimedFlight: [],
    };
  }

  openModal = (status: MilageStatus, claimedFlight: ClaimFlight[]): void =>
    this.setState({ open: true, claimedFlight, status });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.CheckMilageModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        <Content
          {...this.props}
          open={this.state.open}
          closeModal={this.closeModal}
          status={this.state.status}
          claimedFlight={this.state.claimedFlight}
        />
      </S.CheckMilageModalContainer>
    );
  }
}

export default CheckMilageModal;
